/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Allocated capacity widget

Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Row, Button, Card, CardBody } from "reactstrap";

export default function AllocatedCapacity() {
  return (
    <Card className="widget-flat mt-5">
    <CardBody>
    <Row >
      <h4 style={{color:'#003247'}} className="header-title float-left col " >ALLOCATED CAPACITY</h4>
      <Button style={{background:'#003247'}}  className="float-right"><i className="uil  uil-down-arrow "></i></Button>
      </Row>
     
    </CardBody>
  </Card>
  );
}